import { FC, useEffect } from 'react';

import { Button, Tooltip } from '@smartshell/ui-kit';
import cn from 'classnames';

import { useToolConfig } from './constants';
import { ToolbarProps } from './interfaces';
import s from './Toolbar.module.scss';

export const Toolbar: FC<ToolbarProps> = ({ selectedTool, onToolSelect }) => {
  const toolConfig = useToolConfig();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent): void => {
      if (
        e.target instanceof HTMLElement &&
        (e.target.tagName === 'INPUT' ||
          e.target.tagName === 'TEXTAREA' ||
          e.target.isContentEditable)
      ) {
        return;
      }

      const tool = toolConfig.find((t) => t.hotkeyCode === e.code);

      if (tool) {
        e.preventDefault();
        onToolSelect(tool.type);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toolConfig, onToolSelect]);

  return (
    <div className={s.toolbar}>
      {toolConfig.map(({ type, key, icon, hotkey }) => {
        const isActive = selectedTool === type;

        return (
          <Tooltip
            key={type}
            contentClassName={s.tooltip_content}
            content={
              <span className={s.tooltip}>
                {key} {hotkey && <span className={s.hotKey}>{hotkey}</span>}
              </span>
            }
          >
            <Button
              variant={isActive ? 'primary' : 'ghost'}
              size="s"
              onClick={() => onToolSelect(type)}
              className={cn(s.toolButton, isActive && s.active)}
            >
              {icon}
            </Button>
          </Tooltip>
        );
      })}
    </div>
  );
};
